import { useSelector } from 'react-redux';
import { REVIEWS_ID } from 'views/ProductPage/reviews';
import { ProductSection } from 'views/ProductPage/themes/BGH/sections/productSection';
import { ProductReviews } from 'views/ProductPage/reviews/themes/BGH';
import { getTotalNumberOfReviews } from 'views/ProductPage/selector';
import { rm, NO_ELEMENT } from 'utils';

export const Reviews = () => {
  const nbrOfReviews = useSelector(getTotalNumberOfReviews);

  if (nbrOfReviews === 0) {
    return NO_ELEMENT;
  }

  return (
    <ProductSection id={REVIEWS_ID} title={rm('product_section_review_header')}>
      <ProductReviews />
    </ProductSection>
  );
};
